import { useLazyGetCustomQuotesQuery, useRemoveCustomQuoteMutation } from "../features/api/customQuotesApi.ts";

export const useCustomQuotes = () => {
	const [
		deleteCustomQuote,
		{
			error: deleteCustomQuoteError,
			isLoading: deleteCustomQuoteLoading,
			isSuccess: deleteCustomQuoteSuccess,
			reset: resetCustomQuote
		}
	] = useRemoveCustomQuoteMutation();
	const [customQuotesTrigger, { data: customQuotes, isFetching: isCustomQuotesLoading }] =
		useLazyGetCustomQuotesQuery({ pollingInterval: 30_000 });
	return {
		deleteCustomQuote,
		deleteCustomQuoteError,
		deleteCustomQuoteLoading,
		deleteCustomQuoteSuccess,
		isCustomQuotesLoading,
		customQuotes,
		customQuotesTrigger,
		resetCustomQuote
	};
};
